import Moment from 'moment';

export const dateTimeCell = (date, noTime) => {
  // eslint-disable-next-line no-underscore-dangle -- FIXME
  const _format = noTime
    ? `${Moment.localeData().longDateFormat('L')}`
    : `${Moment.localeData().longDateFormat(
        'L'
      )} ${Moment.localeData().longDateFormat('LTS')}`;
  return new Moment(date).format(_format);
};
